// Makes sure the secondaryArray of products doesn't contain any duplicates from the mainArray
// of products And then joins them.

export const getNonDupedJointProductArray = (
  mainArray = [],
  secondaryArray = []
) => {
  const nonDupedItems = secondaryArray.filter(
    i => !mainArray.map(f => f.masterProductId).includes(i.masterProductId)
  );
  return [...mainArray, ...nonDupedItems];
};
